<template>
    <entrance-page-layout :top-bar="true">
        <box-content-message v-if="!isErrorState">
            <template v-slot:icon>
                <img src="@/assets/gifs/verifying.gif"
                     alt="bird"
                     width="90"
                     height="90"
                >
            </template>
            <template v-slot:primaryText>
                <div>Verifying your email</div>
            </template>
            <template v-slot:secondaryText>
                <div class="emailText">We just emailed a confirmation link to <br/>
                    <span class="webBodyStrong">{{email}}</span>
                </div>
            </template>
        </box-content-message>
        <verifying-flow-error-message v-else :error-type="errorType"></verifying-flow-error-message>
    </entrance-page-layout>
</template>

<script>
import BoxContentMessage from '@/pages/entrance/components/BoxContentMessageLayout.vue';
import EntrancePageLayout from '@/pages/entrance/components/EntrancePageLayout.vue';
import VerifyingFlowErrorMessage from '@/pages/entrance/verifyingYourEmail/VerifyingErrorMessageBox.vue';
// eslint-disable-next-line import/no-cycle
import { navigateToAngularRoute } from 'services/utils/angularRouterUtils';
import { getNested } from 'services/utils/objectUtils';
import auth from 'services/auth';
import analytics from 'services/utils/analytics';
import verifyTokenService from 'services/utils/verifyToken';
import firePixelService from 'services/utils/firePixels';
import firePixelConsts from './consts';

export default {
    name: 'verifyingYourEmail',
    props: {
    },
    components: {
        EntrancePageLayout,
        BoxContentMessage,
        VerifyingFlowErrorMessage
    },
    computed: {
        email() {
            if (!this.token) {
                return '';
            }
            const tokenStr = atob(this.token);
            return tokenStr.split(':')[0];
        },
        token() {
            return this.$route.query.token;
        }
    },
    data: () => ({
        tokenData: '',
        isErrorState: false,
        errorType: '',
        firePixelConsts
    }),
    methods: {
        formatErrorMessage(errorMsg) {
            switch (errorMsg) {
            case 'We\'re sorry, there was a problem in the email confirmation process':
                return 'systemError';
            case 'User already exist':
                return 'userExists';
            case 'Confirmation link has expired':
                return 'tokenExpired';
            default:
                return 'systemError';
            }
        },
        async verifyToken() {
            try {
                const response = await verifyTokenService.verifyToken(this.token);
                analytics.track('AccountSignUp', 'signUpVerificationSuccess');
                this.$gtm.track('signup verification');
                this.tokenData = response && response.data ? response.data : {};
                if (window.mixpanel && window.mixpanel.people !== undefined) {
                    window.mixpanel.people.set({ $verified: true });
                }

                // fire leads pixels
                await firePixelService.firePixels(this.firePixelConsts.pixelsToFireAfterVerify).catch(() => {});

                // go to dashboard
                auth.loginWithToken(this.tokenData);
                await navigateToAngularRoute('/');
            } catch (error) {
                const errorMessage = getNested(error, 'response.data.error') || error.message;
                analytics.track('AccountSignUp', 'signUpVerificationError');
                this.isErrorState = true;
                this.errorType = this.formatErrorMessage(errorMessage);
            }
        }
    },
    beforeCreate() {
        if (!this.$route.query.token) {
            this.$router.push({ path: '/signup' });
        }
    },
    created() {
        this.verifyToken();
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.V2";
</style>
